import { ArrowRight } from "lucide-react";
import { PixelWorld } from "./PixelWorld";
import { GrainButton } from "./GrainButton";
import { MaskLines } from "./Reveal";
import { openInquiry, scrollToId } from "../lib/scroll";

export const Hero = () => {
  return (
    <section id="home" data-testid="hero-section" className="px-3 sm:px-5 lg:px-8 pt-4 sm:pt-6">
      <div className="relative overflow-hidden rounded-[1.75rem] sm:rounded-[2.75rem] min-h-[86vh] flex items-center bg-gradient-to-b from-[#F5F2EA] via-[#F1EDE2] to-[#EAE5D6]">
        <div className="absolute inset-0 noise-overlay" />
        <PixelWorld />
        <div className="absolute inset-0 bg-gradient-to-t from-[#EFEADF]/75 via-[#EFEADF]/10 to-transparent pointer-events-none" style={{ top: "74%" }} />

        <div className="relative z-10 px-6 sm:px-10 lg:px-20 pt-20 pb-40 sm:py-24 lg:py-32 w-full max-w-6xl">
          <p
            data-testid="hero-eyebrow"
            className="font-mono text-[11px] sm:text-xs tracking-[0.28em] text-ember mb-6 sm:mb-8"
          >
            LANDSCAPE CONSTRUCTION • DESIGN-BUILD • MANAGEMENT
          </p>
          <MaskLines
            as="h1"
            lines={[
              <>Landscapes built <span className="font-semibold">with</span> <span className="font-serif italic font-normal">experience.</span></>,
              <><span className="font-semibold">Designed</span> to <span className="font-serif italic font-normal">last.</span></>,
            ]}
            className="font-display font-light tracking-[-0.03em] leading-[1.02] text-[2.6rem] sm:text-7xl lg:text-[5.4rem] text-charcoal"
            delay={0.15}
          />
          <p
            data-testid="hero-support"
            className="mt-7 text-base sm:text-xl text-charcoal/90 leading-relaxed max-w-xl font-medium"
          >
            Creating commercial and residential landscapes across Northern &amp; Central California since 1972.
          </p>
          <p className="mt-4 text-sm sm:text-base text-charcoal/70 leading-relaxed max-w-xl">
            Nagel Landscaping brings design, construction and long-term landscape management together to create outdoor environments built for people, property and time.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <GrainButton testid="hero-start-project-button" onClick={() => openInquiry()}>
              START YOUR PROJECT
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </GrainButton>
            <button
              data-testid="hero-view-work-button"
              onClick={() => scrollToId("work")}
              className="group px-7 py-3.5 rounded-full border border-charcoal/25 text-sm font-semibold tracking-wide text-charcoal hover:bg-charcoal hover:text-cream transition-colors duration-300 flex items-center gap-2 bg-cream/60 backdrop-blur-sm"
            >
              VIEW OUR WORK
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
